import { mutationUpdate, type UpdateHookResponse } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useProgramCache } from './cache'
import { toResponseError, type ProgramData, type ProgramUpdateInput, type ProgramUpdateSuccess } from '@terros/common'

export function useUpdateProgram(): UpdateHookResponse<ProgramUpdateInput['program'], ProgramData> {
  const mutation = useTantalimMutation<ProgramUpdateInput, ProgramUpdateSuccess>({
    url: '/program/update',
  })
  const cache = useProgramCache()

  async function update(program: ProgramUpdateInput['program']): Promise<ProgramData> {
    try {
      const { program: updatedProgram } = await mutation.mutateAsync({ program })
      cache.setItem(updatedProgram)
      return updatedProgram
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationUpdate(mutation, update)
}
